module.exports = __webpack_public_path__ + "static/media/bg-large.f20613f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/bg-large.jpg
// module id = 1052
// module chunks = 0